<template>
  <el-dialog
    :close-on-click-modal="false"
    title="修改"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        labelWidth="140px"
      >
        <!-- 司机姓名 -->
        <span slot="carDriverName" slot-scope="prop">{{prop.form.carDriverName}}</span>
        <!-- 司机姓名 end -->
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  driverSalaryEdit,
} from 'api/getPay';
import {mapState} from 'vuex';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '司机姓名',
            value: 'carDriverName',
            slot: true,
          },
          // {
          //   label: '月里程',
          //   value: 'monthMileage',
          //   type: 'input',
          // },
          // {
          //   label: '基本工资',
          //   value: 'basicSalaryFee',
          //   type: 'input',
          // },
          {
            label: '订单工资',
            value: 'orderBaseSalary',
            type: 'input',
            disabled: true,
          },
          {
            label: '月补贴',
            value: 'subsidyFee',
            type: 'input',
          },
          {
            label: '趟数工资',
            value: 'tripPayFee',
            type: 'input',
          },
          {
            label: '里程工资',
            value: 'mileagePayFee',
            type: 'input',
          },
          // {
          //   label: '节油奖',
          //   value: 'saveOilBonus',
          //   type: 'input',
          // },
          // {
          //   label: '实发工资',
          //   value: 'realSalaryFee',
          //   type: 'input',
          // },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
          },
        ],
        rules: { // 表单验证规则
          monthMileage: [ // 月里程
            { required: true, message: '请输入月里程', trigger: 'blur' },
          ],
          basicSalaryFee: [ // 基本工资
            { required: true, message: '请输入基本工资', trigger: 'blur' },
          ],
          orderBaseSalary: [ // 订单工资
            { required: true, message: '请输入订单工资', trigger: 'blur' },
          ],
          subsidyFee: [ // 月补贴
            { required: true, message: '请输入月补贴', trigger: 'blur' },
          ],
          tripPayFee: [ // 趟数工资
            { required: true, message: '请输入趟数工资', trigger: 'blur' },
          ],
          mileagePayFee: [ // 里程工资
            { required: true, message: '请输入里程工资', trigger: 'blur' },
          ],
          saveOilBonus: [ // 节油奖
            { required: true, message: '请输入节油奖', trigger: 'blur' },
          ],
          realSalaryFee: [ // 实发工资
            { required: true, message: '请输入实发工资', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        this.formChange(item);
        this.originData = item;
        item.basicSalaryFee = item.basicSalaryFeeDouble;
        item.subsidyFee = item.subsidyFeeDouble;
        item.tripPayFee = item.tripPayFeeDouble;
        item.mileagePayFee = item.mileagePayFeeDouble;
        item.saveOilBonus = item.saveOilBonusDouble;
        item.realSalaryFee = item.realSalaryFeeDouble;
        item.orderBaseSalary = item.orderBaseSalaryFeeDouble;
        item.monthMileage = item.monthMileageStr;
        this.$refs.customForm.setVal(item);
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },
    formChange (data) {
      // 仅对福鹏展示“服务费字样”的需求，2483为测试车队陈，2536为福鹏，2538为正式环境单翠号的车队
      // 因对福鹏个性化定制表头，所以驾驶员工资列表表头由后端动态配置返回；又因历史数据问题，2022-10月份之前后后端返回表头为新字段，2022-10月份之前（包括10月份）为旧字段，
      // 前端需控制，当修改的工资是10月份后的话，同步后端表头配置字段名
      if (data.settleMonth > '2022-10' && (this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538)) {
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: true,
          names: ['orderBaseSalary', 'subsidyFee', 'tripPayFee', 'mileagePayFee'],
        });
        this.formData.form.map((item) => {
          if (item.label === '基本工资') {
            item.label = '基本服务费';
          }
          if (item.label === '实发工资') {
            item.label = '实发服务费';
          }
        });
        Object.keys(this.formData.rules).forEach((key) => {
          if (key === 'basicSalaryFee') {
            this.formData.rules[key][0].message = '请输入基本服务费';
          }
          if (key === 'realSalaryFee') {
            this.formData.rules[key][0].message = '请输入实发服务费';
          }
        });
      } else {
        this.formData.form.map((item) => {
          if (item.label === '基本服务费') {
            item.label = '基本工资';
          }
          if (item.label === '实发服务费') {
            item.label = '实发工资';
          }
        });
        Object.keys(this.formData.rules).forEach((key) => {
          if (key === 'basicSalaryFee') {
            this.formData.rules[key][0].message = '请输入基本工资';
          }
          if (key === 'realSalaryFee') {
            this.formData.rules[key][0].message = '请输入实发工资';
          }
        });
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: false,
          names: ['orderBaseSalary', 'subsidyFee', 'tripPayFee', 'mileagePayFee'],
        });
      }
      if (this.userInfo.staffTFInfo.tenantId === 2521 || this.userInfo.staffTFInfo.tenantId === 2525) { // 2.0.0绿丝特
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: true,
          names: ['orderBaseSalary', 'tripPayFee', 'mileagePayFee'],
        });
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await driverSalaryEdit({
        ...this.originData,
        ...form,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
